import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { ProductGroup } from "../domain/product-group";
import { CoreData } from "../tools/core-data/core-data";
import { mapper } from "../tools/mapping/mapper";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { ProductGroupDTO } from "./dto/product-group.dto";
import { AppConfig } from "../app.config";

@Injectable({
    providedIn: 'root',
})
export class ProductGroupService extends BaseService {

    private serviceUrl = `${this.config.getConfig('serviceBaseUrl')}api/productgroup`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected override snackBar: MatSnackBar,
        protected override oauthService: OAuthService,
        private loadingTask: LoadingTask,
        protected override router: Router,
        private config: AppConfig) {
        super(router, coreData, oauthService, snackBar);
    }

    getProductGroupByCode(testGroupCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${testGroupCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getProductGroupByCode')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: ProductGroupDTO) => {
                return mapper.map(response, ProductGroupDTO, ProductGroup);
            }));
    }

    // update(pg: ProductGroup) {

    //     this.loadingTask.activateLoading();
    //     return this.http.put(`${this.serviceUrl}`, pg, this.generateHeader()).pipe(
    //         catchError(this.handleError<any>('update')),
    //         finalize(() => this.loadingTask.deactivateLoading()),
    //         map((response: string) => {
    //             return response;
    //         }));
    // }

    delete(productGroupCode: string) {

        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${productGroupCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('delete')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }
}